var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-3",on:{"click":function($event){return _vm.openCsv()}}},[_vm._v("Завантажити CSV")]),_c('rating-department-grid',{attrs:{"items":_vm.items,"total":_vm.total,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }